import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { SmartImage } from 'shared/UI/SmartImage'
import { withOutboundLink } from 'LiveBoard/hocs'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEX_INDICATIONS } from 'shared/helpers/AccessibilityHelper'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import snakeCase from 'lodash/snakeCase'
const get = require("lodash/get")
const isEmpty = require("lodash/isEmpty")

import './style.css.scss'

const LINK_TARGETS = {
  inline: '_self',
  newTab: '_blank'
}

const Image = (props) => {
  useEffect(() => {
    const url = get(props.data, 'link.url')
    url && props.setOutboundUrlAttribute(url)
  },[])

  const getEmptyClass = () => {
    return !!props.data.settings && !isEmpty(props.data.settings)
      ? ""
      : "empty"
  }

  const ImageWrapper = ({ condition, clickableWrapper, nonClickableWrapper, children }) =>
    condition ? clickableWrapper(children) : nonClickableWrapper(children)

  const getSmartImage = () => {
    return <SmartImage config={get(props.data, 'settings', {})} isImgTag={false} />
  }

  const getClickableWrapper = (children) => {
    const handleClick = () => props.onOpenOutboundLink(
      props.data.link.url,
      LINK_TARGETS[props.data.link.open_type],
      {
        area: snakeCase(CTA_AREAS.sideBySide)
      }
    )

    return (
      <span
        className={`side-by-side-image link ${getEmptyClass()} ${ACCESSIBILITY_CLASSES.main}`}
        onClick={handleClick}
        onKeyDown={triggerClickOnEnter}
        tabIndex={handleClick && TAB_INDEX_INDICATIONS.normalFlow}
      >
        {children}
      </span>
    )
  }

  const getNonClickableWrapper = (children) => {
    return (
      <span className={`side-by-side-image ${getEmptyClass()}`}>{children}</span>
    )
  }

  return (
    <ImageWrapper
      condition={!!props.data.settings && props.data.link.url}
      clickableWrapper={children => getClickableWrapper(children)}
      nonClickableWrapper={children => getNonClickableWrapper(children)}>
      <> { getSmartImage() } </>
    </ImageWrapper>
  )
}

Image.propTypes = {
  data: PropTypes.object.isRequired
}

export default withOutboundLink(Image)